import styled from '@emotion/styled';
import { Fonts } from '@styles/index';

export const UpcomingCourses = styled.span`
  color: var(--color-i-red);
  font-weight: ${Fonts.SEMIBOLD};
`;

export const EnrolledCourses = styled.span`
  color: var(--color-i-green);
  font-weight: ${Fonts.SEMIBOLD};
`;

export const CoursesInfo = styled.span`
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
`;
